import React, { useEffect, useState } from 'react';
import { Ibox, Table, ModalAlert } from 'enspire-manager-framework';
import * as actions_admin from 'actions/admin-actions';
import * as toolbox from 'components/common/toolbox';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router';

export default function MessagesTable() {

    const params = useParams();
    const history = useHistory();
    const dispatch = useDispatch();
    const routeLocation = useLocation();
    const admin = useSelector((store) => store.admin);

    useEffect(() => {
        dispatch(actions_admin.subMessages(params.handle));

		return () => {
            const unsubscribe = admin.messages_unsubscribe;
            if (typeof unsubscribe === 'function') unsubscribe();
		};
    }, []);
    
    return (
        <>
            { (!params.message_id || true) &&
                <Ibox key="messages-table" 
                    className="mt-3 mb-5" 
                    title={'Saved Messages'} 
                    show_spinner={admin.messages_pending} 
                    styleContent={{ padding: '15px 10px' }} 
                    no_fade={true}
                >

                    <Table
                        key="saved-messages"
                        data={admin.messages}
                        show_limit={false}
                        show_search={true}
                        highlight_search={true}
                        active_id={params.message_id}
                        active_field={'id'}
                        button={ '+ Message' }
                        button_class="btn btn-primary btn-sm mr-3"
                        button_callback={ () => {
                            let location = toolbox.modifyPath(routeLocation.pathname, 3, '0');
                            history.push({ pathname: location });
                            // dispatch(actions_admin.transform(params.handle));
                        }}
                        button_in_ibox={ true }
                        columns={[
                            { name: 'Title', field: 'title', width: 45 },
                            { name: 'Subject', field: 'subject', width: 45 },
                            { name: 'Modified', field: 'modified', type: 'timestamp', format: 'MMM Do', width: 10 },
                        ]}
                        click_callback={(message) => {
                            let location = toolbox.modifyPath(routeLocation.pathname, 3, message.id);
                            history.push({ pathname: location });
                            const column = document.getElementById('column1');
                            column.scrollTo({ top: 0, behavior: 'smooth' });
                        }}
                        container_margin={270}
                        delete={true}
                        on_delete={(message) => {
                            ModalAlert({
                                title: `Delete message: ${message.subject}?`,
                                text: 'Do you wish to delete this message?',
                                icon: 'question',
                                confirm_color: '#8FBC8B',
                                confirm_text: 'Yes!',
                                show_deny: true,
                                callback_success: () => {
                                    dispatch(actions_admin.deleteMessage(params.handle, message.id, () => {
                                        let location = toolbox.modifyPath(routeLocation.pathname, 3, '', 2);
                                        history.push({ pathname: location });
                                    }));
                                }
                            });
                        }}
                    />
                </Ibox>
            }
        </>
    );
}
